import { render, staticRenderFns } from "./dashboardDetails.vue?vue&type=template&id=21bd8a54&scoped=true&"
import script from "./dashboardDetails.vue?vue&type=script&lang=js&"
export * from "./dashboardDetails.vue?vue&type=script&lang=js&"
import style0 from "./dashboardDetails.vue?vue&type=style&index=0&id=21bd8a54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bd8a54",
  null
  
)

export default component.exports